import intl from "react-intl-universal";
import { COUNTRIES, KYC_STATUS, MOCK_CUSTOMERS } from "./constants";

export const EMPTY_CUSTOMERS_FILTERS = {
  searchQuery: "",
  countries: [],
  kycStatuses: [],
};

export const getCustomersKycStatuses = () =>
  Object.values(KYC_STATUS).map((status) => ({
    id: status.id,
    label: intl.get(status.labelKey),
  }));

export const getCustomersCountries = () =>
  COUNTRIES.map((country) => ({
    id: country.id,
    label: country.label,
  }));

const matchesSearch = (customer, query) => {
  if (!query?.trim()) return true;
  const normalized = query.trim().toLowerCase();
  return [customer.label, customer.email, customer.type, customer.id]
    .filter(Boolean)
    .some((value) => String(value).toLowerCase().includes(normalized));
};

export const filterCustomers = (items = MOCK_CUSTOMERS, filters = EMPTY_CUSTOMERS_FILTERS) =>
  items.filter((customer) => {
    if (!matchesSearch(customer, filters.searchQuery)) return false;
    if (filters.countries?.length && !filters.countries.includes(customer.countryCode)) return false;
    if (filters.kycStatuses?.length && !filters.kycStatuses.includes(customer.kycStatus)) return false;
    return true;
  });

export const hasActiveCustomersFilters = (filters = EMPTY_CUSTOMERS_FILTERS) =>
  Boolean(
    filters.searchQuery?.trim() ||
      filters.countries?.length ||
      filters.kycStatuses?.length
  );

export const isCustomersChipFilterActive = (filters, chipId) => {
  switch (chipId) {
    case "country":
      return Boolean(filters.countries?.length);
    case "kyc":
      return Boolean(filters.kycStatuses?.length);
    default:
      return false;
  }
};

export const buildCustomersFilterTags = (filters = EMPTY_CUSTOMERS_FILTERS) => {
  const tags = [];
  const countries = getCustomersCountries();
  const kycStatuses = getCustomersKycStatuses();

  filters.countries?.forEach((countryId) => {
    const country = countries.find((item) => item.id === countryId);
    if (country) {
      tags.push({ id: `country-${countryId}`, type: "country", value: countryId, label: country.label });
    }
  });

  filters.kycStatuses?.forEach((statusId) => {
    const status = kycStatuses.find((item) => item.id === statusId);
    if (status) {
      tags.push({ id: `kyc-${statusId}`, type: "kyc", value: statusId, label: status.label });
    }
  });

  return tags;
};

export const removeCustomersFilterTag = (filters, tag) => {
  if (tag.type === "country") {
    return {
      ...filters,
      countries: filters.countries.filter((value) => value !== tag.value),
    };
  }

  if (tag.type === "kyc") {
    return {
      ...filters,
      kycStatuses: filters.kycStatuses.filter((value) => value !== tag.value),
    };
  }

  return filters;
};
